"use client";

export interface ImageComponentProps {
  url: string;
  padding: string;
  margin: string;
  height: string;
  width: string;
  objectFit: string;
}

const ImageComponent: React.FC<{
  config: ImageComponentProps;
}> = ({ config }) => {
  return (
    <img
      src={config.url}
      alt="image"
      style={
        {
          "--height": config.height,
          "--width": config.width,
        } as React.CSSProperties
      }
      className={`object-${config.objectFit ?? "cover"} ${config.height ? "h-[var(--height)]" : "h-full"} ${config.width ? "w-[var(--width)]" : "w-full"}`}
    />
  );
};

export default ImageComponent;
